import React from 'react';
import { Forms, SystemText } from '@salesperformanceint/e4shared';

const Search = ({ runSearch, defaultSearch, competencies, defaultCompetencyIds }) => {
    const [search, setSearch] = React.useState(defaultSearch);
    const [competencyIds, setCompetencyIds] = React.useState(defaultCompetencyIds);

    return (
        <div className="mb10">
            <div>
                <Forms.Text
                    id="filter-search"
                    label={SystemText('Admin/Forms/FilePicker/GTMBuddy/Search/Label')}
                    help={SystemText('Admin/Forms/FilePicker/GTMBuddy/Search/Help')}
                    placeholder={SystemText('Admin/Forms/FilePicker/GTMBuddy/Search/Placeholder')}
                    value={search}
                    onChange={x => setSearch(x)}
                    onSubmit={() => runSearch(search, competencyIds)}
                    data-testid="text-search-gtm"
                    icon="fa-search"
                />
                <Forms.Select
                    label={null}
                    data={competencies || []}
                    allowMultiple
                    value={competencyIds}
                    onChange={setCompetencyIds}
                    data-testid="select-search-gtm"
                />
            </div>
            <div className="mb10">
                <button
                    data-testid="button-search-gtm"
                    id="search-button"
                    className="btn btn-primary"
                    onClick={() => runSearch(search, competencyIds)}
                >
                    {SystemText('Admin/Forms/FilePicker/GTMBuddy/Button/Search')}
                </button>
            </div>
        </div>
    );
};

export default Search;
